import Navbar from "../../layouts/Navbar";
import Sidebar from "../../layouts/Sidebar";
import { useLocation } from "react-router-dom";
import axios from "axios";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import React, { useCallback, useEffect, useState } from "react";
import { FaCircle } from "react-icons/fa";
import { Tooltip } from "react-tooltip";
const AdminProfileView = () => {
  const location = useLocation();
  const userId = location.state || {};
  const api = process.env.REACT_APP_API;
  const apikey = process.env.REACT_APP_KEY;

  const [data, setData] = useState({});
  const [attendanceHistory, setAttendanceHistory] = useState([]);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [fulldet, setFulldet] = useState(false);

  const [paymentHistory, setPaymentHistory] = useState([]);
  const [showAll, setShowAll] = useState(false);
  const [popupVisible, setPopupVisible] = useState(false);
  const [popupImage, setPopupImage] = useState("");

  const [attendanceSummary, setAttendanceSummary] = useState({
    present: 0,
    partial: 0,
    absent: 0,
  });


   // Format date YYYY-MM-DD
  const formatDateToLocalYYYYMMDD = (date) => {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  // Fetch attendance
  const getAttendance = useCallback(async () => {
    try {
      const res = await axios.get(`${api}/attendance/my`, {
        headers: { apikey, userid: userId },
      });
      const data = res.data.data || [];
      setAttendanceHistory(data);
    } catch (err) {
      console.error("Attendance fetch error:", err);
    }
  }, [api, apikey, userId]);


   const tileClassName = ({ date, view }) => {
    if (view !== "month") return null;
    const dateStr = formatDateToLocalYYYYMMDD(date);
    const rec = attendanceHistory.find((item) => item.date === dateStr);
    if (!rec) return null;

    switch (rec.status) {
      case "Present":
        return "attendance-present-day";
      case "Half-Day":
        return "attendance-halfday-day";
      case "Absent":
        return "attendance-absent-day";
      default:
        return null;
    }
  };

  // Calendar tile content
  const tileContent = ({ date, view }) => {
    if (view !== "month") return null;
    const dateStr = formatDateToLocalYYYYMMDD(date);
    const rec = attendanceHistory.find((item) => item.date === dateStr);
    if (!rec) return null;

    return (
      <div
        className="attendance-calendar-tile"
        data-tooltip-id={`tt-${dateStr}`}
        data-tooltip-content={`Status: ${rec.status}`}
      >
        <FaCircle style={{ color: "white", fontSize: "0.8rem" }} />
        <Tooltip id={`tt-${dateStr}`} place="top" />
      </div>
    );
  };

  const getProfileData = async () => {
    try {
      const response = await axios.get(`${api}/Admin/profiledatas`, {
        headers: { apikey, userid: userId },
      });

      const rows = response.data.data;
      if (rows.length > 0) setData({ user: rows[0], salaries: rows });
    } catch (error) {
      console.error("Error fetching profile data:", error);
    }
  };



// New useEffect: calculate summary whenever attendanceHistory changes
  const paymentrecord = async () => {
    try {
      const response = await axios.get(`${api}/salary/paymentrecords/${userId}`, {
        headers: { apikey },
      });

      const sortedData = response.data.data.sort((a, b) => b.id - a.id);
      setPaymentHistory(sortedData);
    } catch (error) {
      console.log(error);
    }
  };


  useEffect(() => {
    getProfileData();
    getAttendance();
    paymentrecord();
  }, [getAttendance]);

 
  const openImagePopup = (url) => {
    setPopupImage(url);
    setPopupVisible(true);
  };

  const closeImagePopup = () => {
    setPopupVisible(false);
    setPopupImage("");
  };

  return (
    <div className="container-scroller">
      <Navbar />
      <div className="container-fluid page-body-wrapper d-flex">
        <Sidebar />
        <div className="main-panel">
          <section style={{ backgroundColor: "#eee" }}>
            <div className="container py-5">
              <div className="row">
                {/* --- LEFT COLUMN --- */}
                <div className="col-lg-4">
                  <div className="card mb-4">
                    <div className="card-body text-center">
                      <img
                        src={
                          data?.user?.photo
                            ? `${api}/uploads/${data?.user?.photo}`
                            : "https://mdbcdn.b-cdn.net/img/Photos/new-templates/bootstrap-chat/ava3.webp"
                        }
                        alt="avatar"
                        className="rounded-circle img-fluid"
                        style={{ width: "150px", height:'170px'}}
                      />
                      <h5 className="my-3">{data?.user?.name}</h5>
                       <h5 className="my-3">{data?.user?.designation}</h5>
                      {/* <p className="text-muted mb-1">{data?.user?.role}</p> */}
                      {/* <p className="text-muted mb-4">{data?.user?.designation}</p> */}
                      <p className="text-muted mb-4">{data?.user?.address}</p>
                      
                    </div>
                  </div>
                </div>

                {/* --- RIGHT COLUMN --- */}
                <div className="col-lg-8">
                  <div className="card mb-4">
                    <div
                      className="card-body"
                      style={{
                        overflowY: fulldet ? "auto" : "unset",
                        maxHeight: fulldet ? "350px" : "none",
                      }}
                    >
                      {[
                        ["Full Name", data?.user?.name],
                        ["Employee Code", data?.user?.employee_code],
                        ["User ID", data?.user?.userid],
                        ["Mobile", data?.user?.phonenumber],
                        ["Address", data?.user?.address],
                        ...(fulldet
                          ? [
                              ["Blood Group", data?.user?.bloodgroup],
                              ["Father Name", data?.user?.fathername],
                              ["Father Cell", data?.user?.fathercellnumber],
                              ["Mother Name", data?.user?.mothername],
                              ["Mother Cell", data?.user?.mothercellnumber],
                            ]
                          : []),
                      ].map(([label, value], idx) => (
                        <React.Fragment key={idx}>
                          <div className="row">
                            <div className="col-sm-3">
                              <p className="mb-0">{label}</p>
                            </div>
                            <div className="col-sm-9">
                              <p className="text-muted mb-0">{value}</p>
                            </div>
                          </div>
                          <hr />
                        </React.Fragment>
                      ))}
                    </div>

                    <div
                      style={{ display: "flex", justifyContent: "end" }}
                      onClick={() => setFulldet(!fulldet)}
                    >
                      <p
                        style={{
                          padding: "10px",
                          color: "blue",
                          textDecoration: "underline",
                          cursor: "pointer",
                        }}
                      >
                        {!fulldet ? "See all" : "See less"}
                      </p>
                    </div>
                  </div>

                  {/* ATTENDANCE + PAYMENT */}
               
                </div>
              </div>
                 <div className="row">
                    <div className="col-md-6">
                      <div className="card mb-4 mb-md-0">
                        <div className="card-body">
                            {/* <h5 className="attendance-page-title">My Attendance</h5> */}
                            <h5>My Attendance</h5>

            <div className="attendance-calendar-wrapper">
              <Calendar
                value={selectedDate}
                onChange={setSelectedDate}
                tileClassName={tileClassName}
                tileContent={tileContent}
              />
            </div>

            <div className="attendance-legend">
              <div className="attendance-legend-item">
                <div className="attendance-present"></div> Present
              </div>
              <div className="attendance-legend-item">
                <div className="attendance-halfday"></div> Halfday
              </div>
              <div className="attendance-legend-item">
                <div className="attendance-absent"></div> Absent
              </div>
            </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="card mb-4 mb-md-0">
                        <div className="card-body">
                          <h5>Recent Payment</h5>
                          <div
                            className="card-body p-0"
                            style={{
                              overflowY: showAll ? "auto" : "unset",
                              maxHeight: showAll ? "350px" : "none",
                            }}
                          >
                            {paymentHistory.length > 4 && (
                              <p
                                className="salary_seeall"
                                onClick={() => setShowAll(!showAll)}
                              >
                                {showAll ? "See Less" : "See All"}
                              </p>
                            )}

                            <div className="salary_payment-list">
                              {(showAll
                                ? paymentHistory
                                : paymentHistory.slice(0, 4)
                              ).map((pay, i) => (
                                <div className="salary_payment-card" key={i}>
                                  <div className="salary_payment-info">
                                    <div
                                      className="salary_payment-type"
                                      style={{ fontSize: "10px" }}
                                    >
                                      {pay.paymenttype}
                                    </div>
                                    <div
                                      className="salary_payment-mop"
                                      style={{ fontSize: "10px" }}
                                    >
                                      {pay.mop}
                                    </div>
                                  </div>

                                  <div className="salary_payment-details">
                                    <div>
                                      <div
                                        className="salary_label"
                                        style={{ fontSize: "10px" }}
                                      >
                                        PAY PERIOD
                                      </div>
                                      <div style={{ fontSize: "10px" }}>
                                        {new Date(pay.date)
                                          .toISOString()
                                          .split("T")[0]}
                                      </div>
                                    </div>

                                    <div>
                                      <div
                                        className="salary_label"
                                        style={{ fontSize: "10px" }}
                                      >
                                        TOTAL HOUR
                                      </div>
                                      <div style={{ fontSize: "10px" }}>
                                        {pay.time} hrs
                                      </div>
                                    </div>

                                    <div className="salary_img-wrapper">
                                      <img
                                        src={`${api}/uploads/transactionproof/${pay.proof}`}
                                        alt={pay.userid}
                                        style={{ width: "20px", height: "20px" }}
                                        className="salary_img"
                                        onClick={() =>
                                          openImagePopup(
                                            `${api}/uploads/transactionproof/${pay.proof}`
                                          )
                                        }
                                      />
                                    </div>

                                    <div>
                                      <div
                                        className="salary_label"
                                        style={{ fontSize: "10px" }}
                                      >
                                        PAID TOTAL
                                      </div>
                                      <div
                                        className="salary_amount"
                                        style={{ fontSize: "10px" }}
                                      >
                                        ₹{pay.amount.toLocaleString()}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ))}
                              {paymentHistory.length === 0 && (
                                <p>No payment record found</p>
                              )}
                            </div>

                            {popupVisible && (
                              <div className="salary_popup" onClick={closeImagePopup}>
                                <img
                                  src={popupImage}
                                  alt="Payment Proof"
                                  className="salary_popup-img"
                                  onClick={(e) => e.stopPropagation()}
                                />
                                <span
                                  className="salary_popup-close"
                                  onClick={closeImagePopup}
                                >
                                  &times;
                                </span>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default AdminProfileView;
